module.exports = __webpack_public_path__ + "assets/salary.4d89a806.svg";